// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"q0-z"};